import { useCallback, useState } from "react";

/**
 * Signalement uniforme des champs obligatoires (spec iter123).
 * `spec` = [{ key, label, ok }] recalculé à chaque rendu depuis les valeurs courantes.
 * Après une tentative d'envoi (`validate()`), chaque champ manquant est signalé
 * (bordure rouge + « Champ obligatoire ») et la vue défile jusqu'au premier ;
 * le signalement disparaît dès que le champ est renseigné.
 * Le conteneur du champ doit porter `data-field={key}`.
 */
export function useRequiredFields(spec) {
  const [armed, setArmed] = useState(false);
  const missing = spec.filter((f) => !f.ok);
  const errors = armed ? Object.fromEntries(missing.map((f) => [f.key, f.label])) : {};
  const validate = useCallback(() => {
    setArmed(true);
    if (missing.length) { focusField(missing[0].key); return false; }
    return true;
  }, [missing]);
  const reset = useCallback(() => setArmed(false), []);
  return { errors, missing, validate, reset, armed, has: (k) => !!errors[k] };
}

export function focusField(key) {
  requestAnimationFrame(() => {
    const el = document.querySelector(`[data-field="${key}"]`);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    const target = el.matches("input,textarea,select,button,[tabindex]") ? el : el.querySelector("input:not([type=hidden]),textarea,select,button,[tabindex]");
    target?.focus?.({ preventScroll: true });
  });
}

export const REQUIRED_BORDER = "#e5484d";
/** Style inline à fusionner sur le champ en défaut. */
export const requiredStyle = (bad) => (bad ? { borderColor: REQUIRED_BORDER, boxShadow: `0 0 0 1px ${REQUIRED_BORDER}55` } : {});
/** Classes Tailwind à ajouter sur le champ en défaut. */
export const requiredClass = (bad) => (bad ? "border-[#e5484d] ring-1 ring-[#e5484d]/40 focus-visible:ring-[#e5484d]" : "");
